<template>
  <v-card>
    <v-img
      class="white--text align-end"
      height="280px"
      :src="game.gif"
    >
    <v-card-title> {{ game.name }} </v-card-title>
    </v-img>
    
    <div class="ma-2">
      <v-chip
      class="ma-2"
      color="accent"
      text-color="white"
    >
      {{ game.gameLang }}
    </v-chip>
    
      <v-chip
      class="ma-2"
      color="accent"
      text-color="white"
    >
      {{ game.gameArt }}
    </v-chip>

    
      <v-chip
      class="ma-2"
      color="accent"
      text-color="white"
    >
      {{ game.gameEngine }}
    </v-chip>

    
      <v-chip
      class="ma-2"
      color="accent"
      text-color="white"
    >
      {{ game.gameDuration }}
    </v-chip>
    <v-card-text>
      {{ game.desc }}
    </v-card-text>

    <v-card-text>
      {{ game.devdesc}}
    </v-card-text>

    </div>

    <v-card-actions class="justify-center">
      <v-btn
        color="primary"
        :href="game.url"
        target="_blank"
      >
        Play Here
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    game: {
      type: Object,
    },
  },
};
</script>